<template>
  <project-layout :projectName="this.$options.name">
    <p>Zigzag is a meta fashion shopping mall app for young female users in South Korea. It was my final project at Croquis, the startup I worked for years as a lead designer.</p>
    <img :src="imagePath + 'works-zigzag-01.png'" :alt="this.$options.name" class="mw630" />
    <img :src="imagePath + 'works-zigzag-02.png'" :alt="this.$options.name" class="mw630" />
    <img :src="imagePath + 'works-zigzag-03.png'" :alt="this.$options.name" class="mw630" />
    <img :src="imagePath + 'works-zigzag-04.png'" :alt="this.$options.name" class="mw630" />
    <p>I've created Zigzag's Watch App prototype with Xcode. It's much easier than using Framer or any other third party prototyping tool when creating a Watch App prototype.</p>
    <img :src="imagePath + 'works-zigzag-05.jpg'" :alt="this.$options.name" class="shadow" />
    <video :src="videoPath + 'works-zigzag.mp4'" class="border-light mw280" autoplay loop></video>
    <p>I found that the word Zigzag and 지그재그(Korean name of the app) has some similarity in the visual shape and the length. So I tried to find a font that I can use for English, also can be converted to Korean word with some tweaks.</p>
    <img :src="imagePath + 'works-zigzag-06.svg'" :alt="this.$options.name" class="mw200" />
    <img :src="imagePath + 'works-zigzag-web-01.jpg'" :alt="this.$options.name" class="shadow" />
    <img :src="imagePath + 'works-zigzag-web-02.jpg'" :alt="this.$options.name" class="shadow" />
    <img :src="imagePath + 'works-zigzag-web-03.jpg'" :alt="this.$options.name" class="shadow" />
  </project-layout>  
</template>

<script>
  import ProjectLayout from '@/layouts/ProjectLayout.vue'
  import DataPath from '@/components/DataPath.vue'

  export default {
    name: 'zigzag',
    components: {
      'project-layout': ProjectLayout
    },
    data () {
      return {
        imagePath: '',
        videoPath: ''
      }
    },
    created () {
      this.imagePath = DataPath.data().imagePath + this.$options.name + '/'
      this.videoPath = DataPath.data().videoPath + this.$options.name + '/'
    }
  }
</script>

<style lang="sass" scoped>
</style>


// WEBPACK FOOTER //
// src/contents/Zigzag.vue